import { render, staticRenderFns } from "./MySetTelephone.vue?vue&type=template&id=9c18d64a&"
import script from "./MySetTelephone.vue?vue&type=script&lang=js&"
export * from "./MySetTelephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports